<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset}" ref="observer">
    <artisio-modal size="lg" @hidden="onHidden" @ok.prevent="handleSubmit(onSubmit)" :visible="modal.show"
                   :title="$t('Group Items')" :ok-title="$t('Submit')" modal-class="mobile-full-screen"
                   scrollable :is-loading="loading">
      <div class="d-flex">
        <b-form-checkbox v-model="assignAll" size="lg" class="mb-2" @change="onAssignAll" switch></b-form-checkbox>
        <p class="mr-2" style="font-size: 14px">{{ $t('Group whole quantity') }}</p>
      </div>
      <table class="info-table table table-sm lots-table mb-0">
        <tr>
          <th style="width: 10%">{{ $t('Stock No') }}</th>
          <th style="width: 15%">{{ $t('Item Title') }}</th>
          <th style="width: 15%">{{ $t('Total Quantity') }}</th>
          <th style="width: 20%">{{ $t('Available Quantity') }}</th>
          <th style="width: 20%">{{ $t('Group Quantity') }}</th>
        </tr>
        <tr :key="`items-to-reserve-${index}`" v-for="(model, index) of models">
          <td>
            {{ model.stock_no }}
          </td>
          <td>
            {{ model.title | striptags | truncate(50) }}
          </td>
          <td>
            {{ model.total_quantity }}
          </td>
          <td>
            {{ model.available_quantity }}
          </td>
          <td>
            <input-widget
                :rules="`required|max_value:${model.available_quantity}|min_value:1`"
                :model="model" type="number"
                attribute="reserve_quantity" :label="false"/>
          </td>
        </tr>
      </table>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>
  import ArtisioModal from "../../../core/components/artisio-modal/ArtisioModal";
  import {createNamespacedHelpers} from "vuex";
  import InputWidget from "../../../core/components/input-widget/InputWidget";
  import GroupedItemReserveModel from "@/modules/inventory/group-items/GroupedItemReserve.model.";
  import InventoryService from "@/modules/inventory/InventoryService";
  import {SOURCE_GROUPED_ITEMS_RESERVE_MODAL} from "@/modules/constants";
  import ReservationModel from "@/modules/inventory/Reservation.model";
  import _ from "lodash";

  const {mapActions, mapState} = createNamespacedHelpers('inventory');

  export default {
    name: "GroupedItemsReserveModal",
    components: {
      ArtisioModal,
      InputWidget
    },
    data() {
      return {
        loading: false,
        models: [],
        assignAll: false,
      }
    },
    computed: {
      ...mapState({
        modal: state => state.groupedItemsReserveModal,
        items: state => state.groupedItemsReserveModal.items
      }),
    },
    watch: {
      items() {
        this.items.forEach(item => this.models.push(new GroupedItemReserveModel({
          "stock_no": item.stock_no,
          "inventory_uuid": item.uuid,
          "title": item.short_description,
          "total_quantity": item.quantity,
          "reservations": item.reservations,
          "available_quantity": item.available_quantity,
          "item": _.cloneDeep(item)
        })))
      }
    },
    methods: {
      ...mapActions(["hideGroupedItemsReserveModal", "showModal"]),
      onHidden() {
        this.assignAll = false;
        this.models = [];
        this.hideGroupedItemsReserveModal()
      },
      async onSubmit() {
        let requestData = [];
        let modalSourceInventories = []

        this.models.forEach(m => {
          requestData.push({
            source_inventory_uuid: m.inventory_uuid,
            quantity: m.reserve_quantity
          });
          modalSourceInventories.push({
            source_inventory_uuid: m.inventory_uuid,
            source_inventory: _.cloneDeep(m.item),
            quantity: m.reserve_quantity
          })
        });

        this.loading = true;
        let response = await InventoryService.validateGroupedItems(requestData)
        this.loading = false;
        if (response.success) {
          this.hideGroupedItemsReserveModal();
          this.showModal({
            source: SOURCE_GROUPED_ITEMS_RESERVE_MODAL,
            object: {
              reservations: [],
              // category: response.body.category,
              // category_uuid: response.body.category_uuid,
              // department: response.body.department,
              // department_uuid: response.body.department_uuid,
              customer: response.body.customer,
              customer_uuid: response.body.customer_uuid,
              item_location: response.body.item_location,
              item_location_uuid: response.body.item_location_uuid,
              dynamic_fields: response.body.dynamic_fields,
              is_grouped_item: true,
              receipt: modalSourceInventories[0].source_inventory.receipt,
              receipt_uuid: modalSourceInventories[0].source_inventory.receipt.uuid,
              source_inventories: modalSourceInventories
            }
          });
        } else {
          if (response.body.non_field_errors) {
            const listItemsArr = [];
            response.body.non_field_errors.forEach(err => listItemsArr.push(this.$createElement('li', {}, err)))
            this.$errorDialog(this.$createElement('ul', {class: "mb-0"}, listItemsArr), this.$i18n.t('Validation Error'));
          }
        }

      },
      async onAssignAll() {
        this.models.forEach(model => {
          model.reserve_quantity = !this.assignAll ? model.available_quantity : 1;
        });
      }
    }
  }
</script>

<style scoped>

</style>
